module.exports = __webpack_public_path__ + "img/cheese.6c6651f0.svg";